var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBuyEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M9.35,22.3a12,12,0,1,0,12-12,12,12,0,0,0-12,12",
    transform: "translate(-9.35 -10.305)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_buy-eur",
    transform: "translate(-2059 -1708)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2329",
    "data-name": "Rectangle 2329",
    width: 32,
    height: 32,
    transform: "translate(2059 1708)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4334",
    "data-name": "Group 4334",
    transform: "translate(2231.281 1720.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3223",
    "data-name": "Path 3223",
    transform: "translate(-171.281 -11.429)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 22.5 C 7.928239822387695 22.5 5.040339946746826 21.30378913879395 2.868269920349121 19.13172912597656 C 0.6962100267410278 16.95965957641602 -0.5 14.0717601776123 -0.5 11 C -0.5 7.928239822387695 0.6962100267410278 5.040339946746826 2.868269920349121 2.868269920349121 C 5.040339946746826 0.6962100267410278 7.928239822387695 -0.5 11 -0.5 C 14.0717601776123 -0.5 16.95965957641602 0.6962100267410278 19.13172912597656 2.868269920349121 C 21.30378913879395 5.040339946746826 22.5 7.928239822387695 22.5 11 C 22.5 14.0717601776123 21.30378913879395 16.95965957641602 19.13172912597656 19.13172912597656 C 16.95965957641602 21.30378913879395 14.0717601776123 22.5 11 22.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11 0 C 4.924869537353516 0 0 4.924869537353516 0 11 C 0 17.07513046264648 4.924869537353516 22 11 22 C 17.07513046264648 22 22 17.07513046264648 22 11 C 22 4.924869537353516 17.07513046264648 0 11 0 M 11 -1 C 14.20532035827637 -1 17.21878051757812 0.2482204437255859 19.48527908325195 2.514720916748047 C 21.75177955627441 4.781219482421875 23 7.794679641723633 23 11 C 23 14.20532035827637 21.75177955627441 17.21878051757812 19.48527908325195 19.48527908325195 C 17.21878051757812 21.75177955627441 14.20532035827637 23 11 23 C 7.794679641723633 23 4.781219482421875 21.75177955627441 2.514720916748047 19.48527908325195 C 0.2482204437255859 17.21878051757812 -1 14.20532035827637 -1 11 C -1 7.794679641723633 0.2482204437255859 4.781219482421875 2.514720916748047 2.514720916748047 C 4.781219482421875 0.2482204437255859 7.794679641723633 -1 11 -1 Z",
    stroke: "none",
    fill: "#1d3960"
  })), /*#__PURE__*/React.createElement("g", {
    id: "united-states",
    transform: "translate(-171.28 -11.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(0.38 2.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M244.87,192.094h11.507a11.04,11.04,0,0,0-.38-2.877H244.87Z",
    transform: "translate(-234.758 -183.483)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M244.87,58.529h9.888a11.086,11.086,0,0,0-2.545-2.877H244.87Z",
    transform: "translate(-234.758 -55.652)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M103.48,458.745a10.907,10.907,0,0,0,6.836-2.4H96.644A10.907,10.907,0,0,0,103.48,458.745Z",
    transform: "translate(-92.861 -439.144)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M10.054,325.659H28.822a10.976,10.976,0,0,0,1.235-2.877H8.819A10.976,10.976,0,0,0,10.054,325.659Z",
    transform: "translate(-8.819 -311.314)",
    fill: "#d80000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M5.108,1.722h1L5.178,2.4l.357,1.1L4.6,2.821,3.666,3.5l.308-.949A11.088,11.088,0,0,0,1.836,4.934h.322l-.6.432q-.139.232-.267.471l.284.874-.53-.385q-.2.419-.361.856L1,8.147H2.158l-.935.679.357,1.1L.645,9.246l-.56.407A11.134,11.134,0,0,0,0,11.028H11.028V0A10.975,10.975,0,0,0,5.108,1.722Zm.427,8.2L4.6,9.246l-.935.679.357-1.1-.935-.679H4.244l.357-1.1.357,1.1H6.113l-.935.679ZM5.178,5.614l.357,1.1L4.6,6.033l-.935.679.357-1.1-.935-.679H4.244l.357-1.1.357,1.1H6.113ZM9.491,9.925l-.935-.679-.935.679.357-1.1-.935-.679H8.2l.357-1.1.357,1.1h1.155l-.935.679ZM9.134,5.614l.357,1.1-.935-.679-.935.679.357-1.1-.935-.679H8.2l.357-1.1.357,1.1h1.155Zm0-3.212.357,1.1-.935-.679L7.621,3.5l.357-1.1-.935-.679H8.2l.357-1.1.357,1.1h1.155Z",
    fill: "#0052b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4607",
    "data-name": "Group 4607",
    transform: "translate(2057.148 1705.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    transform: "translate(8.852 9.808)",
    fill: "#fff",
    stroke: "#1d3960",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(8.852 9.808)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 28.564,
    height: 28.773,
    transform: "translate(-2.228 -2.455)",
    fill: "#00237c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M54.921,15.753l.368,1.133h1.191l-.963.7.368,1.133-.963-.7-.963.7.368-1.133-.963-.7h1.191Z",
    transform: "translate(-42.875 -14.455)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M54.921,92.557l.368,1.133h1.191l-.963.7.368,1.133-.963-.7-.963.7.368-1.133-.963-.7h1.191Z",
    transform: "translate(-42.875 -72.959)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M93.392,54.283l.368,1.133h1.191l-.963.7.368,1.133-.964-.7-.963.7.368-1.133-.963-.7h1.191Z",
    transform: "translate(-72.18 -43.804)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M16.519,54.154l.368,1.133h1.191l-.963.7.368,1.133-.963-.7-.963.7.368-1.133-.964-.7h1.191Z",
    transform: "translate(-13.623 -43.706)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M21.638,34.7l.368,1.133H23.2l-.964.7.368,1.133-.964-.7-.963.7.368-1.133-.963-.7h1.191Z",
    transform: "translate(-17.523 -28.885)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M35.335,20.617,35.7,21.75h1.191l-.964.7.368,1.133-.963-.7-.964.7.368-1.133-.964-.7h1.191Z",
    transform: "translate(-27.956 -18.16)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M87.563,34.7l.368,1.133h1.191l-.963.7.368,1.133-.963-.7-.963.7.368-1.133L86,35.83h1.191Z",
    transform: "translate(-67.739 -28.885)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M73.737,20.617l.368,1.133H75.3l-.964.7.368,1.133-.963-.7-.964.7.368-1.133-.964-.7h1.191Z",
    transform: "translate(-57.208 -18.16)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M21.638,73.1l.368,1.133H23.2l-.964.7.368,1.132-.964-.7-.963.7.368-1.132-.963-.7h1.191Z",
    transform: "translate(-17.523 -58.137)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M35.335,86.8l.368,1.133h1.191l-.964.7.368,1.133-.963-.7-.964.7.368-1.133-.964-.7h1.191Z",
    transform: "translate(-27.956 -68.57)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M87.563,73.1l.368,1.133h1.191l-.963.7.368,1.132-.963-.7-.963.7.368-1.132-.963-.7h1.191Z",
    transform: "translate(-67.739 -58.137)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M73.737,86.8l.368,1.133H75.3l-.964.7.368,1.133-.963-.7-.964.7.368-1.133-.964-.7h1.191Z",
    transform: "translate(-57.208 -68.57)",
    fill: "#fc0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuyEur);
export default __webpack_public_path__ + "static/media/icon_buy-eur.127cc8eac9f0a725d3bb53b24750fd08.svg";
export { ForwardRef as ReactComponent };